import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/core/utils/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-lg font-poppins",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "border border-stroke-secondary text-secondary-text",
        green: "bg-green-20 text-primary-text",
        blue: "bg-blue-20 text-primary-text",
        purple: "bg-purple-20 text-primary-text",
        magenta: "bg-magenta-20 text-primary-text",
        gold: "bg-gold-10 text-primary-text",
        red: "bg-red-20 text-primary-text",
        orange: "bg-orange-20 text-primary-text",
        aqua: "bg-aqua-20 text-primary-text",
        gray: "bg-gray-10 text-primary-text",
        LEAD: "bg-green-10 text-primary-text",
        IN_CONTACT: "bg-blue-10 text-primary-text",
        SCHEDULED: "bg-purple-10 text-primary-text",
        CLOSED: "bg-gold-10 text-primary-text",
        LOST: "bg-red-10 text-primary-text",
        PAID: "bg-orange-10 text-primary-text",
      },
      size: {
        sm: "px-2 py-[0.3rem] text-sm",
        md: "px-2.5 py-[0.44rem] text-md",
        lg: "px-3 py-2 text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  ),
);

Badge.displayName = "Badge";

export { Badge, badgeVariants };
